<template>
  <div class="list-item-alt">
    <!-- Contenedor de título y botón -->
    <div class="list-item-header">
      <strong>{{ layer.name }}</strong>
      <button class="btn-collapsible" @click="toggleList">
        <font-awesome-icon :icon="showList ? 'chevron-up' : 'chevron-down'" style="font-size: 1.5em" />
      </button>
    </div>

    <transition name="expand">
      <div class="items-list-collap" v-show="showList">
        <div v-if="legendItems.length">
          <div v-for="(item, i) in legendItems" :key="i" class="legend-entry">
            <!-- Si ArcGIS trae ícono -->
            <img v-if="item.icon" :src="item.icon" class="legend-icon" :width="item.width || 20"
              :height="item.height || 20" :alt="item.title || 'Leyenda'" />

            <!-- Si es GeoServer o item sin icono -->
            <span v-else class="legend-symbol" :style="{
              backgroundColor: item.fill,
              opacity: item.opacity != null ? item.opacity : 1,
              border: item.stroke,
            }"></span>

            <span class="legend-label">{{ item.title }}</span>
          </div>
        </div>

        <p v-else style="color: #999; font-size: 0.85em">No hay leyenda disponible.</p>
      </div>
    </transition>
  </div>
</template>

<script>

import { UrlHandler } from "@/services/utils/UrlHandler.js"

export default {
  props: ["layer"],
  data() {
    return {
      showList: false,
      legendItems: [],
    };
  },

  mounted() {
    this.loadLegend();
  },

  methods: {
    toggleList() {
      this.showList = !this.showList;
    },

    async loadLegend() {
      try {
        const provider = this.layer?.provider?.name;
        if (!provider) return;

        console.log("Este es el provider para cargar la leyenda:", provider);

        switch (provider) {
          case "geoserver": {
            console.log("Leyenda geoserver");

            const { workspace, datastore } = this.layer.provider.geoserverdata;
            const baseURL = UrlHandler.getBaseUrl(this.layer);

            const url = `${baseURL}/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=application/json&LAYER=${workspace}:${datastore}`;
            console.log("URL de leyenda geoserver:", url);
            const response = await fetch(url);
            const json = await response.json();

            const rules = json?.Legend?.[0]?.rules || [];

            this.legendItems = rules
              .filter((r) => r?.symbolizers?.length)
              .map((r) => {
                const sym =
                  r.symbolizers[0].Polygon ||
                  r.symbolizers[0].Line ||
                  r.symbolizers[0].Point ||
                  {};

                return {
                  title: r.title || r.name || "Sin título",
                  fill: sym.fill || "transparent",
                  opacity: sym["fill-opacity"] || 1,
                  stroke: sym.stroke
                    ? `${sym["stroke-width"] || 1}px solid ${sym.stroke}`
                    : "1px solid #000",
                };
              });
            break;
          }

          case "arcgis":
            console.log("Aca va la logica de arcgis", provider);
            console.log("Capa:", this.layer);
            const baseUrl = UrlHandler.getBaseUrl(this.layer);

            const arcgisUrl = `${baseUrl}/legend?f=pjson`;
            const res = await fetch(arcgisUrl);
            const resJson = await res.json();
            console.log("Respuesta de arcgis:", resJson);

            const layers = resJson.layers || [];

            let targetId = this.layer.codigo
            if (targetId === null || targetId === undefined || targetId === "") {
              targetId = "0"
            }
            const arcgisLayer = layers.find((l) => String(l.layerId) === targetId);

            if (!arcgisLayer) {
              console.warn("No se encontró leyenda para layerId:", targetId);
              this.legendItems = [];
              return;
            }

            this.legendItems = (arcgisLayer.legend || []).map((item) => ({
              title: item.label?.trim() || arcgisLayer.layerName || "Sin título",

              icon: item.imageData
                ? `data:${item.contentType};base64,${item.imageData}`
                : null,

              fill: item.fillColor ? `rgba(${item.fillColor.join(",")})` : "transparent",

              stroke: item.strokeColor
                ? `1px solid rgba(${item.strokeColor.join(",")})`
                : "1px solid #000",

              width: item.width,
              height: item.height,
            }));
            break;

          default:
            console.warn("Provider no soportado:", provider);
        }
      } catch (err) {
        console.warn("Error al cargar leyenda:", err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.list-item-alt {
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 8px;
  margin-bottom: 8px;
}

.list-item-alt:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.list-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 4px;
}

.list-item-header strong {
  font-size: 0.85rem;
  color: #334155;
  font-weight: 600;
}

.items-list-collap {
  margin-top: 6px;
  padding-left: 4px;
}

.legend-entry {
  display: flex;
  align-items: center;
  margin: 4px 0;
}

.legend-symbol {
  width: 18px;
  height: 18px;
  border-radius: 3px;
  margin-right: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
}

.legend-icon {
  margin-right: 10px;
  border-radius: 2px;
}

.legend-label {
  font-size: 0.8rem;
  color: #475569;
  line-height: 1.3;
}

.btn-collapsible {
  border: none;
  background: transparent;
  color: #94a3b8;
  cursor: pointer;
  transition: all 0.2s;
  padding: 2px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-collapsible:hover {
  color: #006fb3;
  background: #f0f9ff;
}

/* Transitions */
.expand-enter-active,
.expand-leave-active {
  transition: all 0.25s ease-in-out;
  max-height: 500px;
  opacity: 1;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
  margin: 0;
  padding: 0;
}
</style>
